import RestService from "../RestService";
import REST_URLS from "../RestUrls.constants";

const base = REST_URLS.COURSE.baseUrl;
const endpoints = REST_URLS.COURSE.endpoints;

export default {
  getCourses() {
    let url = base + endpoints.courses;
    return RestService.getRequest(url);
  },

  getCourseIds() {
    let url = base + endpoints.courseIds;
    return RestService.getRequest(url);
  },

  createCourse(courseId, description) {
    let url = base + endpoints.createCourse;
    return RestService.postRequest(url, {
      courseId: courseId,
      description: description
    });
  },

  deleteCourse(courseId) {
    let url = base + endpoints.deleteCourse;
    return RestService.deleteRequest(url, {
      data: {
        courseId: courseId
      }
    });
  },

  updateDescription(courseId, description) {
    let url = base + endpoints.updateDescription;
    return RestService.putRequest(url, {
      courseId: courseId,
      description: description
    });
  },

  addResources(resources) {
    let url = base + endpoints.addResources;
    return RestService.postFiles(url, resources);
  },

  getResource(resourceId) {
    let url = base + endpoints.resource.replace("{resourceId}", resourceId);
    return RestService.getFiles(url);
  },

  deleteResource(courseId, resourceId) {
    let url = base + endpoints.deleteResource;
    return RestService.deleteRequest(url, {
      courseId: courseId,
      resourceId: resourceId
    });
  },

  createCategory(courseId, category) {
    let url = base + endpoints.createCategory;
    return RestService.postRequest(url, { courseId, category });
  },

  updateCategory(courseId, category) {
    let url = base + endpoints.updateCategory;
    return RestService.postRequest(url, { courseId, category });
  },

  deleteCategory(courseId, category) {
    let url = base + endpoints.deleteCategory;
    return RestService.deleteRequest(url, { data: { courseId, category } });
  }
};
